import { render, staticRenderFns } from "./mahjongTiger.vue?vue&type=template&id=0fabc904&scoped=true"
import script from "./mahjongTiger.vue?vue&type=script&lang=js"
export * from "./mahjongTiger.vue?vue&type=script&lang=js"
import style0 from "./mahjongTiger.vue?vue&type=style&index=0&id=0fabc904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fabc904",
  null
  
)

export default component.exports